import { Search } from "lucide-react";

export function SearchBox() {
  return (
    <div className="flex items-center gap-2 px-3.5 py-2 rounded-[10px] border border-sc-glass-border bg-sc-input-bg backdrop-blur-[10px] text-sc-text-muted text-[13px] cursor-pointer">
      <Search size={16} />
      <span>Search...</span>
      <kbd className="ml-4 text-[9px] px-1.5 py-0.5 rounded bg-sc-glass border border-sc-glass-border text-sc-text-dim font-mono">
        ⌘K
      </kbd>
    </div>
  );
}
